import { CommandActionAsync } from "src/app/abstract/command/command-action-async.service";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";
import { CloneService } from "../clone/clone.service";
import { WidgetsService } from "../widgets/widgets.service";
import { Logger } from "src/app/core/logger";
import { WidgetsMetadataService } from "../widgets/widgets-metadata.service";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";

@Injectable()
export class CommandResequenceSectionsService extends CommandActionAsync {
    constructor(private widgetsCloneService: CloneService,
        private widgetsService: WidgetsService,    
        private widgetsMetadataService: WidgetsMetadataService,
        private logger:Logger) {
        super();
    }

    /**
     * Resequence sections inside a provided root node
     * @param widget (Sub)Node where to start resequencing
     * @param parent Should be a container
     * @returns Number of Questions hit
     */
    public async executeAsync(widget:WidgetsAbstract, parent: WidgetsAbstract|undefined): Promise<number> {
        let tempParent = parent;
        if (widget) {
            if (!parent)
                tempParent = widget;
            const numSections = await this.widgetsService.resequenceSections(widget, tempParent as WidgetsContainerAbstract);
            if (numSections) {
                // this.logger.log('Resequencing sections (' + numSections + ')' );                
                return numSections;
            } else
                throw new Error("No Sections Found");           
        }
        throw new Error("An origin Node needs to be provided.");
    }
}
